import styled from 'styled-components';
import { StyledTable as MatrixStyledTable } from 'flow/editor/components/NodeEditorDrawer/MatrixModel/styles';

export const StyledColorPickerCell = styled.td`
  && {
    padding: 0;
  }
`;

export const StyledTable = styled(MatrixStyledTable)`
  tr td:first-child {
    min-height: 42px;
  }
`;

export const StyledReadOnlyTable = styled(MatrixStyledTable)`
  /* Override width to match bullet chart width */
  width: 100%;

  /* CHANGED from MatrixModel: We don't have a header row, so don't apply gray to all cells in first row */
  /* MatrixModel: tr:first-child td { background-color: var(--cl-gray-200); } */
  && tr td {
    border: 1px solid var(--cl-gray-300);
    border-top: none;
    border-right: none;
    border-radius: 0;
  }

  tr td:last-child {
    border-right: 1px solid var(--cl-gray-300);
  }

  tr:first-child td {
    background-color: transparent;
    border-top: 1px solid var(--cl-gray-300);
  }

  tr:first-child td:nth-child(2) {
    border-top-left-radius: 0;
  }

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0;
  }

  /* Override matrix model styling for first cell */
  tr:first-child td:first-child {
    background-color: var(--cl-gray-200);
    border: none;
    border-bottom: 1px solid var(--cl-gray-300);
    border-top-left-radius: var(--cl-radius-1);
  }

  /* Style first column to match editable table styling */
  tbody > tr > td:nth-of-type(1) {
    border-bottom: 1px solid var(--cl-gray-300);
    background-color: var(--cl-gray-200);
    padding-right: var(--cl-space-4);
    text-align: right;
  }
`;
